export class ValidateUserInfoResultDto {
  isAlreadyApproved: boolean;
  isMissingValidationInformation: boolean;
  isSuccess: boolean;
  errorMessage: boolean;
}
